import { Stack, Typography, useTheme } from "@mui/material";

const FooterBar = () => {
  const theme = useTheme();
  return (
    <Stack
      sx={{
        background: theme.palette.background.layout,
        width: "100%",
        py: 6,
        px: 2,
      }}
    ></Stack>
  );
};

export default FooterBar;
